var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"lk-wrapper"},[(_vm.user.role_id != 3)?_c('Account'):_c('AccountShop')],1)}
var staticRenderFns = []

export { render, staticRenderFns }